<!--
 * @Author: QWX
 * @Description:对账结算基本信息
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-11 15:40:03
-->
<template>
  <el-card >
    <div slot="header" class="">
      <span class="saas-card-header-name">对账结算基本信息 </span>
      <span class="records-link" v-if="isRecordPage"><i class="el-icon-info" ></i> 本单是历史对账结算单</span>
      <span class="records-link" v-else><i class="el-icon-info"></i> 本单是最新对账结算单，点击<el-link type="primary" @click="openRecords">变更记录</el-link>查看最新记录</span>
    </div>
    <div class="">
      <el-form
        ref="relateForm"
        label-position="right"
        :model="baseInfo"
        label-width="180px"
        :gutter="20"
        disabled
      >
        <el-row :gutter="20" >
          <el-col :span="24">
            <el-row :gutter="20" >
              <el-col :span="12">
                <el-form-item label="对账结算单编号：" prop="accountCode" >
                  <el-input  :value="baseInfo.accountCode" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对账结算单位名称：" prop="accountName" >
              <el-input  :value="baseInfo.accountName" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对账结算单位编号：" prop="accountCorp" >
              <el-input  :value="baseInfo.accountCorp" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对账结算联系人：" prop="contact" >
              <el-input  :value="baseInfo.contact" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对账结算联系电话：" prop="contactPhone" >
              <el-input  :value="baseInfo.contactPhone" >
                <el-select
                  slot="prepend"
                  :value="baseInfo.contactPhonePrefix"
                  style="width:88px"
                >
                  <!-- <el-option label="+86" value="86"></el-option> -->
                  <el-option
                    v-for="(item, index) in enums.phoneAreaCodeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >{{ item.label }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商名称：" prop="supplierName" >
              <el-input  :value="baseInfo.supplierName" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商编号：" prop="supplierCode" >
              <el-input  :value="baseInfo.supplierCode" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商联系人：" prop="supplierContact" >
              <el-input  :value="baseInfo.supplierContact" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商联系电话：" prop="supplierPhone" >
              <el-input  :value="baseInfo.supplierPhone" >
                <el-select
                  slot="prepend"
                  :value="baseInfo.supplierPhonePrefix"
                  style="width:88px"
                >
                  <!-- <el-option label="+86" value="86"></el-option> -->
                  <el-option
                    v-for="(item, index) in enums.phoneAreaCodeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >{{ item.label }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRecordPage">
            <el-form-item label="对账结算凭证：" prop="supplierCode" >
              <el-link type="primary"  @click="showCertDialog">对账结算凭证.pdf</el-link>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import changeRecord from '@/components/reconciliationAndSettlement/changeRecord'
import reconciliationAndSettlementCertDialog from '@/components/dialog/reconciliationAndSettlementCertDialog'
import { enums } from '@/lib/enum'
export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      enums
    }
  },
  computed: {
    /**
     * @description: 是否记录页面
     */
    isRecordPage() {
      return this.$route.name.endsWith('ReconciliationAndSettlementRecords')
    }
  },
  methods: {
    // 显示电子凭证
    showCertDialog() {
      this.$zl.dialog.openFull(reconciliationAndSettlementCertDialog, {
        accountId: this.baseInfo.id
      })
    },
    openRecords() {
      this.$zl.dialog.openFull(changeRecord, this.baseInfo.itemId).then(id => {
        this.$router.push({
          name: this.$store.state.system === 'purchaser' ? 'PurchaserReconciliationAndSettlementRecords' : 'SupplierReconciliationAndSettlementRecords',
          query: { id }
          // params: {
          //   isReLoad: true
          // }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.records-link{
     font-size: 12px;
     padding-left: 16px;
     i{
       color: #FBA232FF;
       font-size: 16px;
     }
}
</style>
